"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styleProps = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styleProps = _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]));

exports.styleProps = styleProps;
var _default = {
  styleProps: styleProps
};
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9jb21wb25lbnRzL3Byb3BUeXBlcy5qcyJdLCJuYW1lcyI6WyJzdHlsZVByb3BzIiwiUHJvcFR5cGVzIiwib2JqZWN0T2YiLCJvbmVPZlR5cGUiLCJzdHJpbmciLCJudW1iZXIiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7OztBQUVPLElBQU1BLFVBQVUsR0FBR0MsbUJBQVVDLFFBQVYsQ0FDeEJELG1CQUFVRSxTQUFWLENBQW9CLENBQUNGLG1CQUFVRyxNQUFYLEVBQW1CSCxtQkFBVUksTUFBN0IsQ0FBcEIsQ0FEd0IsQ0FBbkI7OztlQUlRO0FBQ2JMLEVBQUFBLFVBQVUsRUFBVkE7QUFEYSxDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuXG5leHBvcnQgY29uc3Qgc3R5bGVQcm9wcyA9IFByb3BUeXBlcy5vYmplY3RPZihcbiAgUHJvcFR5cGVzLm9uZU9mVHlwZShbUHJvcFR5cGVzLnN0cmluZywgUHJvcFR5cGVzLm51bWJlcl0pXG4pO1xuXG5leHBvcnQgZGVmYXVsdCB7XG4gIHN0eWxlUHJvcHMsXG59O1xuIl19